<script setup>
import headerDefault from "@/components/App/header-default/header-default.vue";
import footerDefault from "@/components/App/footer/footer.vue";
import defaultPage from "@/views/App/PageItem/components/default-page.vue";
import ticker from "@/components/App/ticker.vue";

import {ref, onBeforeMount, watch} from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from "vue-router";
import { useCommonComposable } from '@/composables/commonComposable.js';

import { useHead } from "@vueuse/head";
import AboutUs from "@/views/App/PageItem/components/about-us.vue";

const router = useRouter();
const route = useRoute();
const store = useStore();

const actualPage = ref([])
const getPage = async () => {
    try {
        const fetchParams = {pageUrl: route.params.url};
        await store.dispatch("page/fetchActualPage", fetchParams);
        actualPage.value = JSON.parse(JSON.stringify(store.state.page.actualPage[0]));

        useHead({
            title: `${actualPage.value['Заголовок']} — Baller | Оригинальные джерси`,
            meta: [
                {name: 'description', content: "Описание страницы"}
            ],
        })
    } catch (error) {
        await router.replace({ name: 'not-found' });
    }
}
onBeforeMount(async () => {
    await getPage();
})

watch(() => route.params.url, (newValue, oldValue) => {
    if (newValue !== oldValue) {
        getPage()
    }
})

</script>

<template v-if="actualPage['Тип']">
    <about-us v-if="route.params.url === 'about-us'"></about-us>
    <default-page v-else-if="actualPage['Тип'] === 'Default'"
                  :page="actualPage">
    </default-page>
</template>

<style scoped lang="scss">
</style>